import { createFileRoute, useParams } from '@tanstack/react-router';
import { JourneysDataIndexItemHandoff } from '@/pages/workspaces/data-index/routing';
import { DataIndexItemResolver } from '@/pages/workspaces/data-index/data-index-item-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

/** The `journeys` spelling of an object or relationship attribute's own page. */
function JourneysDataIndexNestedItemRoute() {
  const { type, itemId, nestedItemId } = useParams({
    from: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId',
  });

  return (
    <LastWorkspaceResolver>
      <DataIndexItemResolver segment={type} itemId={itemId} nestedItemId={nestedItemId}>
        {(address) => <JourneysDataIndexItemHandoff address={address} />}
      </DataIndexItemResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/$nestedItemId',
)({
  component: JourneysDataIndexNestedItemRoute,
});
